import React, {  useEffect, useState } from 'react'

const MwModal = ({ children, onShow, setOnShow , custWidth  }) => {
    const [isHidden, setIsHidden] = useState(true);

    const onHide = () => {
        setIsHidden(true);
        setOnShow(false);
    };

    useEffect(() => {
        setIsHidden(!onShow);
    }, [onShow, setIsHidden]);

    return (
        <div
            className={`flex flex-col items-center justify-center h-screen w-full bg-gray-700/75 absolute inset-0 z-50 ${
                !isHidden ? "flex" : "hidden"
            }`}
        >
            <div className={`w-11/12 ${custWidth ? custWidth : "md:w-4/6"}   bg-gray-300 rounded-lg overflow-y-auto relative`}>
                <div className="h-full bg-slate-100">
                    {children}
                </div>
            </div>
        </div>
    );
};


export default MwModal